export const TOING_PC_SUPPORTED_IMAGE_TYPES = [
    "image/png",
    "image/jpeg",
    "image/heic",
    "image/heif",
    "image/avif",
    "image/webp",
] as const;

export const UPLOAD_BUTTON_BG_PRIMARY = "#C30886";
export const UPLOAD_BUTTON_BG_SECONDARY = "#02060C";

export const UPLOAD_BUTTON_LABEL_BILL = "Upload cart screenshot";
export const UPLOAD_BUTTON_LABEL_AGAIN = "Upload Again";

export const IMAGE_UPLOADER_BUTTON_BASE_STYLE = {
    margin: "0 auto",
    border: "none",
    height: "44px",
    width: "100%",
    borderRadius: "32px",
} as const;

export const TOING_PC_MAX_FILE_SIZE_MB = 5;

export const ADD_IMAGE_CLOUDINARY_ID = "portal/static-assets/icons/camera.svg";
